import script from "./search-this-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-this-area.vue?vue&type=script&setup=true&lang=ts"

import "./search-this-area.vue?vue&type=style&index=0&id=307b5cfb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-307b5cfb"]])

export default __exports__